import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	tabsExpandButtonLabel: {
		id: 'relay.search-page.results.product-results.third-party.conversation-search-result.tabs-related-links-label',
		defaultMessage: 'Related links',
		description:
			'Label for the expand button showing MS Teams Channel Tabs pinned in a channel, presented as related links',
	},
});
